import axios from 'axios';
import { getBearerGrantTypeAuthHeaders } from '../helpers/auth_helpers';
export const getFSCDisclaimer = async (options) => {
    const requestOptions = {
        method: 'get',
        url: `${API_HOST}/api/configs/fsc-disclaimer`,
        headers: {
            'Content-Type': 'application/json',
            Authorization: getBearerGrantTypeAuthHeaders(),
        },
    };
    if (options === null || options === void 0 ? void 0 : options.cancelToken) {
        requestOptions.cancelToken = options === null || options === void 0 ? void 0 : options.cancelToken;
    }
    return axios(requestOptions);
};
